'use strict';

/**
 * 判断元素相对Y轴的位置;
 * @param {Element} el 元素对象
 * @return {Number} [-1, 1]; 相对页面的位置; 从最上不可见到最下不可见;
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (top, height, clientHeight) {
  var containStatus = void 0;
  if (top < -height) {
    // 在页面上方的场景;
    containStatus = -1;
  } else if (top < 0) {
    // 页面上方出现一点, 返回对高度百分比;
    containStatus = top / height;
  } else if (top + height < clientHeight) {
    // 完全展现
    containStatus = 0;
  } else if (top < clientHeight) {
    // 页面下面出现一点, 返回对高度百分比;
    containStatus = (top + height - clientHeight) / height;
  } else if (top >= clientHeight) {
    // 完全在页面下面;
    containStatus = 1;
  }

  return containStatus;
};

module.exports = exports['default'];